import React from 'react';
import { Link } from 'react-router-dom';

import { FaRegStar } from 'react-icons/fa';

import './BlogFeaturedArea.css';

const BlogFeaturedArea = ({ featuredBlogPosts }) => {
  return (
    <div className='blog-featured-area-container'>
      <h3>Featured Posts</h3>
      <div className='blog-featured-list-container'>
        {featuredBlogPosts?.map((post, i) => (
          <div key={i} className='blog-featured-link-container'>
            <Link to={`/blog/${post.slug}`}>
              <div className='blog-featured-star-icon-container'>
                <FaRegStar className='blog-featured-star-icon' />
              </div>
              {post.title + '...'}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogFeaturedArea;
